<template>
  <AdminFieldWrapper :label="label">
    <AdminInputSingleSelect
      v-bind="{ ...$attrs, ...$props }"
      v-on="$listeners"
      @keydown.esc="$emit('update')"
      @change="$emit('update')"
      @blur="isFocused = false"
    >
      <template #invalid="{ theSelection }">
        <v-btn
          v-tooltip="getTooltipHtml(invalidTooltip)"
          color="grey grey--text text--darken-3"
          outlined
          small
          class="font-italic caslon--font"
          >{{ theSelection }}</v-btn
        >
      </template>
    </AdminInputSingleSelect>
  </AdminFieldWrapper>
</template>

<script>
import { Model } from '@vuex-orm/core'
import AdminInputSingleSelect from '@/components/AdminInputSingleSelect'
import AdminFieldWrapper from '@/components/AdminFieldWrapper'
export default {
  name: 'AdminFieldSingleSelect',
  components: { AdminInputSingleSelect, AdminFieldWrapper },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    label: {
      type: String,
      require: true,
      default: 'Select',
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    chips: {
      type: Boolean,
      default: true,
    },
    invalidTooltip: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      theSelection: this.value,
    }
  },
  methods: {
    getTooltipHtml(string) {
      if (!string) {
        return {}
      }
      return {
        content: `<div class="proxima--font">${string}</div>`,
        html: true,
      }
    }, // getTooltipHtml
  },
}
</script>

<style>
.selection-title {
  cursor: pointer;
}
.single-select.v-text-field > .v-input__control > .v-input__slot:before {
  display: none;
}
</style>
